<template>
    <select
        v-model="sortType"
        @change="updateOrder"
        class="select pr-1 bg-transparent form-control"
        :id="id"
    >
        <option 
            v-for="sort in sorts" 
            :key="sort.key" 
            :value="sort.value"
        >
            {{ sort.text }}
        </option>
    </select>
</template>

<script>
export default {
    name: 'ChangeOrderPosts',
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            sortType: 'CHRONODESC',
            sorts: [
                {
                    key: 1,
                    value: 'CHRONODESC',
                    text: 'Mais Novas'
                },
                {
                    key: 2,
                    value: 'CHRONOASC',
                    text: 'Mais Antigas'
                },
                {
                    key: 3,
                    value: 'ALPHABASC',
                    text: 'Ordem Alfabetica A-Z'
                },
                {
                    key: 4,
                    value: 'ALPHABDESC',
                    text: 'Ordem Alfabetica Z-A'
                },
                {
                    key: 5,
                    value: 'CUSTOM',
                    text: 'Personalizada(arraste)'
                }
            ]
        }
    },
    methods: {
        updateOrder() {
            console.log('updateOrder', this.sortType);

            this.$emit('updateSortType', this.sortType);
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/molecules/ChangeOrderPosts.vue